import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ManageRewardsComponent} from './manage-rewards/manage-rewards.component';
import {PointsHistoryComponent} from './points-history/points-history.component';
import {PointRewardDetailComponent} from "./point-reward-detail/point-reward-detail.component";
import {GetYourRewardsComponent} from "./get-your-rewards/get-your-rewards.component";
import {LoyaltyPromotionsComponent} from "./loyalty-promotions/loyalty-promotions.component";
import {PartnerDetailComponent} from "./loyalty-promotions/partner-detail/partner-detail.component"
import {MobilePartnerDetailComponent} from "./loyalty-promotions/mobile-partner-detail/mobile-partner-detail.component";


const routes: Routes = [
    {
        path: '',
        component: ManageRewardsComponent
    },
    {
        path: 'dashboard',
        component: ManageRewardsComponent
    },
    {
        path: 'dashboard.html',
        component: ManageRewardsComponent
    },
    {
        path: 'points-history',
        component: PointsHistoryComponent
    },
    {
        path: 'points-history.html',
        component: PointsHistoryComponent
    },
    {
        path: 'point-reward-details',
        component: PointRewardDetailComponent
    },
    {
        path: 'point-reward-details.html',
        component: PointRewardDetailComponent
    },
    {
        path: 'get-your-rewards',
        component: GetYourRewardsComponent
    },
    {
        path: 'get-your-rewards.html',
        component: GetYourRewardsComponent
    },
    {
        path: 'partners',
        component: LoyaltyPromotionsComponent
    },
    {
        path: 'partners.html',
        component: LoyaltyPromotionsComponent
    },
    {
        path: 'partner-detail',
        component: PartnerDetailComponent
    },
    {
        path: 'partner-detail.html',
        component: PartnerDetailComponent
    },
    {
        path: 'mobile-partner-detail',
        component: MobilePartnerDetailComponent
    },
    {
        path: 'mobile-partner-detail.html',
        component: MobilePartnerDetailComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ManageRewardsRoutingModule {
}
